import React, { Component } from "react";
import { connect } from "react-redux";
import { t } from "../../../../core/translate";
import { selectors as userSelectors } from "../../../../../redux/user";
import { selectors as brandSelectors } from "../../../../../redux/brand";
import { actions as userActions } from "../../../../../redux/user";
import { actions as libraryActions } from "../../../../../redux/ui/library";
import { selectors as librarySelectors } from "../../../../../redux/ui/library";
import { Wrapper, StyledBackground } from "./styles";
import { withAllMatches } from "../../../../components/mediaquery/breakpoints";
import Languages from "../languages";
import Header from "./header";
import InstallMobile from "./install-mobile";
import Account from "./account";
import Tools from "./tools";
import Apps from "./apps";
import Help from "./help";
import Store from "./store";
import Signout from "./signout";

class Slideout extends Component {
  constructor() {
    super();
    this.state = {
      languagesOpen: false
    };

    this.openLanguages = this.toggleLanguages.bind(this, true);
    this.closeLanguages = this.toggleLanguages.bind(this, false);
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  toggleLanguages(languagesOpen) {
    this.setState({ languagesOpen });
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
  }

  updateDimensions() {
    const { initialWidth, isOpen, isSmall } = this.props;
    const currentWidth = window.innerWidth;
    const windowResized = currentWidth !== initialWidth;

    if (windowResized && isOpen && isSmall) {
      this.props.closeMobileHeaderMenu();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  render() {
    const { currentUser, width, isSmall, isMobileMenuOpen } = this.props;
    const ACCORDION_HEADING_LEVEL = 3;
    if (isSmall && isMobileMenuOpen) {
      return (
        <Wrapper>
          {this.state.languagesOpen ? (
            <Languages
              close={this.closeLanguages}
              currentLocale={currentUser.locale}
              isSmall
              width={width}
            />
          ) : (
            <StyledBackground width={width}>
              <Header />
              <InstallMobile />
              <Account
                openLanguages={this.openLanguages}
                headingLevel={ACCORDION_HEADING_LEVEL}
              />
              <Tools headingLevel={ACCORDION_HEADING_LEVEL} />
              <Apps headingLevel={ACCORDION_HEADING_LEVEL} />
              <Help headingLevel={ACCORDION_HEADING_LEVEL} />
              <Store />
              <Signout />
            </StyledBackground>
          )}
          <button
            onClick={this.props.closeMobileHeaderMenu}
            style={{
              height: "100vh",
              width: "calc(100vw - 260px)",
              zIndex: 3,
              WebkitAppearance: "none",
              background: "transparent",
              border: "none"
            }}
            aria-label={i18n.t("base.close-menu")}
          />
        </Wrapper>
      );
    }
    return false;
  }
}

const mapStateToProps = state => ({
  currentUser: userSelectors.getUser(state),
  isMobileMenuOpen: librarySelectors.isMobileMenuOpen(state),
  signoutRedirect: brandSelectors.getBrandValue(
    state,
    "Locations.signout_redirect"
  ),
  showSignOut: brandSelectors.getBrandValue(state, "Menu.sign_out"),
  showStore: brandSelectors.getBrandValue(state, "Store.visible"),
  storeLabel: brandSelectors.getBrandValue(
    state,
    "Store.label",
    t("global-bar.store", "Store")
  ),
  storeSso: brandSelectors.getBrandValue(state, "Store.sso"),
  storeUrl: brandSelectors.getBrandedStoreUrl(state)
});

const mapDispatchToProps = dispatch => ({
  signout: (currentUser, redirectTo) =>
    dispatch(userActions.signOut(currentUser, redirectTo)),
  closeMobileHeaderMenu: () => dispatch(libraryActions.closeMobileHeaderMenu())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAllMatches(Slideout));
